import React from 'react'
import styled from 'react-emotion'
import { ArrowIcon, Button, spacer } from 'stylist'
import { compose, withProps, defaultProps } from 'recompose'
import { withRouter } from 'react-router-dom'

const BackButton = styled(Button)`
  padding-right: ${spacer(2)};
  padding-left: ${spacer(2)};
`

export default compose(
  withRouter,
  defaultProps({
    children: <ArrowIcon size="1.25rem" direction="left" />
  }),
  withProps(({ history, to, fallbackTo }) => ({
    kind: 'ghost',
    onClick: () => {
      to
        ? history.push(to)
        : history.length > 1 ? history.goBack() : history.push(fallbackTo)
    }
  }))
)(BackButton)



// WEBPACK FOOTER //
// ./src/components/BackButton.js